// extracted by mini-css-extract-plugin
export var button = "_ou-0";